// Built-in sidebar icons, referenced by name from NavEntry.icon.
import {
  Activity,
  Bug,
  Building,
  Circle,
  ClipboardCheck,
  FileText,
  FolderOpen,
  Globe,
  Layers,
  LayoutDashboard,
  ListChecks,
  type LucideIcon,
  Plug,
  ScrollText,
  Server,
  Settings,
  ShieldAlert,
  ShieldCheck,
  SquareCheck,
  TriangleAlert,
  UserCheck,
  Users,
} from 'lucide-react'

export const NAV_ICONS: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  tasks: ListChecks,
  controls: ShieldCheck,
  frameworks: Layers,
  monitoring: Activity,
  events: ScrollText,
  evidence: FolderOpen,
  audits: ClipboardCheck,
  risks: TriangleAlert,
  vendors: Building,
  assets: Server,
  vulnerabilities: Bug,
  personnel: Users,
  policies: FileText,
  remediation: ShieldAlert,
  'access-reviews': UserCheck,
  trust: Globe,
  connections: Plug,
  settings: Settings,
  me: SquareCheck,
}

export const DEFAULT_NAV_ICON: LucideIcon = Circle
